import IconLoading from 'components/Common/Icons/IconLoading';
import useCategoryURLParams from 'hooks/useCategoryURLParams';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import fetchDesignsForPreviousPageOperation from 'store/category/operation/fetchDesignsForPreviousPageOperation';
import getFamiliesOffset from 'store/category/selector/getFamiliesOffset';
import getPreviousPageNr from 'store/category/selector/getPreviousPageNr';
import isCategoryLoading from 'store/category/selector/isCategoryLoading';
import styles from './LoadMoreItemsBefore.module.scss';

const LoadMoreItemsBefore = () => {
  const dispatch = useDispatch();
  const familiesOffset = useSelector(getFamiliesOffset);
  const isLoading = useSelector(isCategoryLoading);
  const previousPageNr = useSelector(getPreviousPageNr);
  const { queryString } = useCategoryURLParams(previousPageNr);

  const [fetchingPage, setFetchingPage] = useState(false);

  const loadMore = (e: any) => {
    e.preventDefault();
    setFetchingPage(true);
    dispatch(fetchDesignsForPreviousPageOperation());
  };

  const { t } = useTranslation();

  useEffect(() => {
    if (isLoading && fetchingPage) {
      return () => {
        setFetchingPage(false);
      };
    }
    return () => {};
  }, [isLoading, fetchingPage]);

  if (familiesOffset === 0) {
    return null;
  }

  return (
    <div className={styles.loadMoreItemsBefore}>
      <div className={styles.loadMoreButton}>
        {fetchingPage && <IconLoading className={styles.loadingIcon} />}
        <Link to={queryString} className={fetchingPage ? styles.hidden : ''} onClick={loadMore}>
          {t('txt_previous_page')}
        </Link>
      </div>
    </div>
  );
};

export default LoadMoreItemsBefore;
